import { throttle } from 'underscore';

window.globalConfigs = {};

window.addEventListener('resize', throttle(onViewportResize, 100));

window.opta_settings = {
  subscription_id: '996cf5a7e7d89eba508208bbb2604497',
  language: 'en_GB',
  timezone: 'Europe/London'
};

function CustomEvent(event, params) {
  const evt = document.createEvent('CustomEvent');

  params = params || { bubbles: false, cancelable: false, detail: undefined };
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

  return evt;
}

CustomEvent.prototype = window.Event.prototype;
window.CustomEvent = CustomEvent;

const resizeEvent = new CustomEvent('fa.viewportResize');

function onViewportResize() {
  globalConfigs.viewportIsBelowLarge = window.matchMedia('(max-width: 991px)').matches;

  broadcastWindowResizeEvent();
}

function broadcastWindowResizeEvent() {
  window.dispatchEvent(resizeEvent);
}

onViewportResize();



// WEBPACK FOOTER //
// ./scripts/globalConfigs.js